// todo: replace with new root constant
export const DAYS_NEEDED_TO_ONBOARD = 7;
